//import libraries
import { Component, OnInit,Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppPermissions } from '../../../../constants/app-permission';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { SuperAdminService } from '../../../../services/superadmin.service';
import { GeneralService } from '../../../../services/general.service';
import { CustomersService } from '../../../../services/customers.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
declare var $: any;

@Component({
  selector: 'app-package_create',
  templateUrl: './package-create.component.html',
  styleUrls: ['./package-create.component.css']
})
  
export class CreatePackageComponent implements OnInit {

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;
  @Input() ID: string;
  @Input() type: string;


  modalTitle: string;
  lang: any;
  generalLang: any;
  edit_data: any;
  id: any;
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  langDropdownSettings:any;
  langOptions:any;
  selectedLangOptions:any;
  subscriptionStatusOptions:any;
  subscriptionDropdownSettings:any;
  userdata:any;
  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private customersService: CustomersService,
    public bsModalRef: BsModalRef,
    private route: ActivatedRoute,
    private superadminService : SuperAdminService,
    private router: Router) { }

  ngOnInit() {
    this.modalTitle = (this.type == "edit")?"Edit Package":"Add Package"
    this.langDropdownSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3
    };    
    this.langOptions = [
      { item_id: "english", item_text: 'English' },
      { item_id: "italian", item_text: 'italian' }
    ];    

    this.subscriptionDropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 8
    };      

    this.subscriptionStatusOptions = [
      {
        item_id: 1,
        item_text: "Timetable",
        image: "http://www.sciencekids.co.nz/images/pictures/flags96/India.jpg",
      },
      {
        item_id: 2,
        item_text: "Service",
        image: "http://www.sciencekids.co.nz/images/pictures/flags96/Spain.jpg",
      },
      {
        item_id: 3,
        item_text: "Human Resource",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/United_Kingdom.jpg",
      },
      {
        item_id: 4,
        item_text: "Measurement Tool",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Canada.jpg"
      },
      {
        item_id: 5,
        item_text: "Problem Solving",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Israel.jpg",
      },
      {
        item_id: 6,
        item_text: "Document Management",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Brazil.jpg",
      },
      {
        item_id: 7,
        item_text: "Clients",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Barbados.jpg",
      },
      {
        item_id: 8,
        item_text: "Consultancy",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Mexico.jpg",
      },
      {
        item_id: 9,
        item_text: "Academy",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Mexico.jpg",
      },
      {
        item_id: 10,
        item_text: "Project",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Mexico.jpg",
      },
      {
        item_id: 11,
        item_text: "Audit",
        image:
          "http://www.sciencekids.co.nz/images/pictures/flags96/Mexico.jpg",
      },                  
    ];    
    this.FormBuild();
    if(this.type =="edit"){
      this.getInstallInfo()
    }
  }

  getInstallInfo(){
    this.superadminService.getPackageDetail(this.ID).subscribe(
      (res) => {
          console.log(res)
          if(res.status){                    
              this.userdata = res.data.user_data
              this.FormBuildUpdate()
          }
      }
  );
  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      package: ['', [Validators.required]],
      timetable:[],
      timetable_value:[],
      servicing:[],
      servicing_value:[],
      human_resource:[],
      human_resource_value:[],
      mesurement_tool:[],
      mesurement_tool_value:[],
      problem_solving:[],
      probsolve_value:[],
      doc_management:[],
      docmang_value:[],
      clients:[],
      clients_value:[],
      consultancy:[],
      consultancy_value:[],
      academy:[],
      academy_value:[],
      project:[],
      project_value:[],
      audit:[],
      audit_value:[],      
      id: '',
      submit: 'update',
    });


  }



  FormBuildUpdate(): void {

    this.createForm.patchValue({
      package: this.userdata.package_name,
      id: this.userdata.id,
      timetable:(this.userdata.timetable == 1 || this.userdata.timetable == "1")?0:this.userdata.timetable,
      timetable_value:this.userdata.timetable_value,
      servicing:(this.userdata.servicing == 1 || this.userdata.servicing == "1")?0:this.userdata.servicing,
      servicing_value:this.userdata.servicing_value,
      human_resource: (this.userdata.human_resource == 1 || this.userdata.human_resource == "1")?0:this.userdata.human_resource,
      human_resource_value:this.userdata.humanresources_value,
      mesurement_tool:(this.userdata.mesurement_tool == 1 || this.userdata.mesurement_tool == "1")?0:this.userdata.mesurement_tool,
      mesurement_tool_value:this.userdata.meastools_value,
      problem_solving:(this.userdata.problem_solving == 1 || this.userdata.problem_solving == "1")?0:this.userdata.problem_solving,
      probsolve_value:this.userdata.probsolve_value,
      doc_management:(this.userdata.doc_management == 1 || this.userdata.doc_management == "1")?0:this.userdata.doc_management,
      docmang_value:this.userdata.docmang_value,
      clients:(this.userdata.clients == 1 || this.userdata.clients == "1")?0:this.userdata.clients,
      clients_value:this.userdata.clients_value,
      consultancy:(this.userdata.consultancy == 1 || this.userdata.consultancy == "1")?0:this.userdata.consultancy,
      consultancy_value:this.userdata.consultancy_value,
      academy:(this.userdata.academy == 1 || this.userdata.academy == "1")?0:this.userdata.academy,
      academy_value:this.userdata.academy_value,
      project:(this.userdata.project == 1 || this.userdata.project == "1")?0:this.userdata.project,
      project_value:this.userdata.project_value,
      audit:(this.userdata.audit == 1 || this.userdata.audit == "1")?0:this.userdata.audit,
      audit_value:this.userdata.audit_value,            
      submit: 'update',
      
    });

  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }


  onSubmit() {
    this.createFormSubmitted = true;
    if (this.createForm.invalid)
      return;

    this.superadminService.addUpdatePackage(this.createForm.value,this.type).subscribe(
      res => {

        if (res.status) {
          
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide()
          if (res.action == 'insert') {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['/super/'+AppFrontRoutes.ADMIN_PACKAGE_LIST]);
              });
          } else {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/super/'+AppFrontRoutes.ADMIN_PACKAGE_LIST]);
            });
          }
        }
        else {
          this.generalService.notify_msg('error', res.data);
        }

      }
    );

  }

}
